import { withRouteParams } from 'shared/hoc'

import POI from './POI'

const POIView = ({ language, placeOfInterestId }) => (
    <POI language={language} placeOfInterestId={placeOfInterestId} key={`${language}-${placeOfInterestId}`} />
)

export default withRouteParams(POIView)
